<template>
  <div
    id="app"
    :class="appCls"
    :env="appEnv"
    @mouseenter="inApp = true"
    @mouseleave="inApp = false"
  >
    <MainNav v-if="isLogin" ref="mainNav" />
    <div v-if="isLogin" class="main-content">
      <RouterView />
    </div>
    <StatusBar v-if="isLogin" />
    <MenuSettings />
    <SideEffects v-if="isLogin" />
  </div>
</template>

<script>
import MainNav from 'mod/MainNav'
import MenuSettings from 'mod/MenuSettings'
import StatusBar from 'mod/StatusBar'
import SideEffects from 'mod/SideEffects'
import { mapGetters } from 'vuex'
import appShortcutMixin from 'mixins/appShortcutMixin'
import appPermissionAlertMixin from 'mixins/appPermissionAlertMixin'
import { TIMER_EXPRESSION } from 'const/common'
import getEnv from 'utils/getEnv'
const REFRESH_HK_LEVEL_LOOP = 'REFRESH_HK_LEVEL_LOOP'

export default {
  name: 'TradeUPWeb',
  mixins: [appShortcutMixin, appPermissionAlertMixin],
  components: {
    MainNav,
    MenuSettings,
    StatusBar,
    SideEffects
  },
  data() {
    return {
      appEnv: getEnv() === 'production' ? '' : getEnv(),
      inApp: false, // 鼠标移动到 APP 容器外
      timer: null
    }
  },
  computed: {
    ...mapGetters(['isDeposited', 'isLogin', 'hasHkLv2Permission', 'ukDelay']),
    ...mapGetters({ stock: 'activeStock' }),
    appCls() {
      const { stockColor, blinkActive } = this.$store.state.settings
      return {
        app: true,
        [`stock-color--${stockColor}`]: stockColor,
        [`blink-active-${blinkActive}`]: blinkActive
      }
    }
  },
  watch: {
    isLogin(isLogin) {
      if (isLogin) {
        this.resumeOrCreate()
      } else {
        this.pause()
      }
    }
  },
  mounted() {
    if (this.isLogin) {
      this.createTimer()
      this.$store.dispatch('getQuotePermission')
      this.$store.dispatch('getMessageUnreadCount')
    }
  },
  methods: {
    createTimer() {
      this.timer = this.$cron(TIMER_EXPRESSION.PERMISSION).interval(
        REFRESH_HK_LEVEL_LOOP,
        () => {
          this.$store.dispatch('getQuotePermission')
          this.$store.dispatch('getMessageUnreadCount')
        }
      )
    },
    resumeOrCreate() {
      if (this.timer) {
        this.timer.resume()
      } else {
        this.createTimer()
      }
    },
    pause() {
      if (this.timer) this.timer.pause()
    }
  }
}
</script>

<style lang="less">
@import '~styles/index.less';

html,
body {
  height: 100%;
  overflow: hidden;
  background: var(--bg-default);
}
.app {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  .main-nav {
    position: absolute;
    left: 0;
    top: 0;
  }
  .main-content {
    display: flex;
    flex: 1;
    margin-left: 60px;
    min-height: 0;
  }

  &:before {
    content: attr(env);
    position: fixed;
    display: block;
    width: 30px;
    overflow: hidden;
    text-align: center;
    text-shadow: 1px 1px 2px lightpink;
    transform: rotate(-45deg) scale(0.8);
    transform-origin: bottom;
    z-index: 99999;
  }
}
</style>
